import "./AboutUs.module.css";
import Navbar from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Commitment from "./sections/Commitment";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Navbar />
      <Story />
      <Commitment />
      <Cta />
      <Footer />
    </div>;
}